import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import {getDefaultLang} from "../auth/authHelper";
import enTranslation from './languages/en.json';
import deTranslation from './languages/de.json';
import svTranslation from './languages/sv.json';
import swTZTranslation from './languages/swTZ.json';
let defaultLanguage = getDefaultLang();
i18n
    .use(initReactI18next)
    .init({
        resources: {
            en: {
                translation: enTranslation,
            },
            de: {
                translation: deTranslation
            },
            sv: {
                translation: svTranslation
            },
            swTZ: {
                translation: swTZTranslation
            },
        },
        lng: defaultLanguage ? defaultLanguage : 'en',
        fallbackLng: 'en',
        interpolation: {
            escapeValue: false,
        },
    });

export default i18n;
